import React from 'react';
import PropTypes from 'prop-types';
import { isEmpty } from '../../../utils/obj-utils';
import { formMessageConstants } from '../../../utils/constants/form-message-constants';

function InstallmentTable({ installments }) {
    function displayInstallmentsTable() {
        if (isEmpty(installments)) {
            return null;
        }

        return (<div className='change-history'>
            <h2>{formMessageConstants.installments}</h2>
            <div className='table'>
                <div className='flex-grid table-header'>
                    <div className='col'>{formMessageConstants.dueDate}</div>
                    <div className='col'>{formMessageConstants.amountDue}</div>
                    <div className='col'>{formMessageConstants.amountPaid}</div>
                    <div className='col'>{formMessageConstants.paymentDate}</div>
                </div>
                {displayInstallmentRows(installments)}
            </div>
        </div>);
    }

    function displayInstallmentRows() {
        return installments.map((installment, index) => {
            return displayInstallmentRow(installment, index);
        });
    }
    function displayInstallmentRow(installment, index) {
        return (<div className='flex-grid last' key={index}>
            <div className='col'><span className='header'>{formMessageConstants.dueDate}</span><span>{installment.formattedDueDate}</span></div>
            <div className='col'><span className='header'>{formMessageConstants.amountDue}</span><span>{installment.formattedAmountDue}</span></div>
            <div className='col'><span className='header'>{formMessageConstants.amountPaid}</span><span>{installment.formattedAmountPaid}</span></div>
            <div className='col'><span className='header'>{formMessageConstants.paymentDate}</span>
                <span>
                    {isEmpty(installment.paymentDate) ?
                        <a className='print-button' href={installment.paymentUrl}>
                            <span className='ico'>
                                <svg aria-hidden='true'
                                    focusable='false'
                                    data-prefix='far'
                                    data-icon='credit-card'
                                    role='img'
                                    xmlns='http://www.w3.org/2000/svg'
                                    viewBox='0 0 576 512'
                                    className='icon-print'>
                                    <path
                                        fill='white'
                                        d='M527.9 32H48.1C21.5 32 0 53.5 0 80v352c0 26.5 21.5 48 48.1 48h479.8c26.6 0 48.1-21.5 48.1-48V80c0-26.5-21.5-48-48.1-48zM54.1 80h467.8c3.3 0 6 2.7 6 6v42H48.1V86c0-3.3 2.7-6 6-6zm467.8 352H54.1c-3.3 0-6-2.7-6-6V256h479.8v170c0 3.3-2.7 6-6 6zM192 332v40c0 6.6-5.4 12-12 12h-72c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h72c6.6 0 12 5.4 12 12zm192 0v40c0 6.6-5.4 12-12 12H236c-6.6 0-12-5.4-12-12v-40c0-6.6 5.4-12 12-12h136c6.6 0 12 5.4 12 12z'>
                                    </path>
                                </svg>
                            </span>
                            {formMessageConstants.payByCreditCard}
                        </a> : installment.paymentDate}
                </span>
            </div>
        </div>);
    }

    return displayInstallmentsTable();
}

InstallmentTable.propTypes = {
    installments: PropTypes.array.isRequired
};

export default InstallmentTable;
